export default [
  {
    path: 'me',
    name: 'me',
    component: () => import('@/views/pages/user/users-list/UsersView.vue'),
    meta: {
      pageTitle: 'User',
      breadcrumb: [
        {
          text: 'User',
          active: true,
        },
      ],
      resource: 'Home',
    },
  },
]
